import { list } from './list/list.reducer';
import { detail } from './detail/detail.reducer';
import { combineReducers } from 'redux';
import { batch } from './batch/batch.reducer';
import { storage } from './storage/storage.reducer';
import { ScanRack } from './scan-rack/scan-rack.reducer';
import { Event } from './event/event.reducer';

export const Inventory = combineReducers({
  list,
  detail,
  batch,
  storage,
  ScanRack,
  Event
});
